import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

export interface ExtendRoleDialogData {
  /** Anzeigename der Person, deren Rollenvergabe verlaengert wird. */
  userName: string;
  /** Bezeichnung der Rolle. */
  roleDescription: string;
  /** Bisheriges Ende der Vergabe, bereits formatiert und nur zur Anzeige. */
  currentValidUntil: string;
}

/**
 * Dialog zum Verlaengern einer bestehenden Rollenvergabe. Person, Rolle und das
 * bisherige Ende stehen fest, gewaehlt wird nur das neue Gueltig bis.
 */
@Component({
  selector: 'app-extend-role-dialog',
  templateUrl: './extend-role-dialog.component.html',
  standalone: false,
})
export class ExtendRoleDialogComponent {
  form = new FormGroup({});

  formModel: {
    userName: string;
    roleDescription: string;
    currentValidUntil: string;
    validUntil: Date;
  };

  formFields: FormlyFieldConfig[];

  constructor(
    private translateService: TranslateService,
    public dialogRef: MatDialogRef<ExtendRoleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ExtendRoleDialogData
  ) {
    this.formModel = {
      userName: this.data.userName,
      roleDescription: this.data.roleDescription,
      currentValidUntil: this.data.currentValidUntil,
      // Vorbelegung ein Jahr im Voraus, im Dialog aenderbar.
      validUntil: moment().add(1, 'year').startOf('day').toDate(),
    };

    const newValidUntilLabel = this.translate('label__newValidUntil');

    this.formFields = [
      {
        key: 'userName',
        type: 'input',
        wrappers: ['readOnly'],
        props: {
          label: this.translate('label__user'),
          readOnly: true,
        },
      },
      {
        key: 'roleDescription',
        type: 'input',
        wrappers: ['readOnly'],
        props: {
          label: this.translate('label__role'),
          readOnly: true,
        },
      },
      {
        key: 'currentValidUntil',
        type: 'input',
        wrappers: ['readOnly'],
        props: {
          label: this.translate('label__currentValidUntil'),
          readOnly: true,
        },
      },
      {
        key: 'validUntil',
        type: 'datepicker',
        wrappers: ['width', 'form-field'],
        props: {
          width: '250px',
          label: newValidUntilLabel,
          datepickerOptions: {
            min: new Date(),
          },
          required: true,
        },
        validation: {
          messages: {
            required: this.translateService.instant('formErrors.required', {
              label: newValidUntilLabel,
            }),
          },
        },
      },
    ];
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.form.get('validUntil')?.value as Date);
  }

  private translate(key: string): string {
    return this.translateService.instant(
      `administration.users.extend_dialog.${key}`
    );
  }
}
